import React from 'react';
import { dateFormat } from '../../utils';
import '../../assets/css/copy-right.less';
import { GdImage } from '@gaodun.com/gui-pc';

type CopyRightProps = {
    rightBottomNone?: boolean;
};

const CopyRight = (props: CopyRightProps) => (
    <div className={!!props.rightBottomNone ? 'copy-right copy-right-none' : 'copy-right'}>
        <div className="copy-right-text">
            <a 
                rel="nofollow" 
                target="_blank" 
                href="https://www.beian.gov.cn/portal/registerSystemInfo?recordcode=31010902001351"
            >
                <GdImage className='copy-right-icon' src="https://simg01.gaodunwangxiao.com/uploadimgs/tmp/upload/202305/16/b0eba_20230516143339.png" alt=""/>
                沪公网安备31010902001351号
            </a>
        </div>
        <div className="copy-right-text">
            {/* <a href="https://credit.cecdc.com/CX20170620038863810881.html">互联网3.15产品监督认证</a> */}
            <a href="https://www.gaodun.com/licence/icp.html">沪B2-20160190</a>
            <a href="https://www.gaodun.com/licence/ppl.html">广播电视节目制作经营许可证</a>
        </div>
        <div className="copy-right-text">Copyright © 2006-{dateFormat(new Date(), 'YYYY')} 上海高顿教育科技有限公司，All Rights Reserved.</div>
    </div>
);

export default CopyRight;
